import { useState, useEffect } from 'react';
import { useStoreClosed } from '@lib/context/store-closed-context';

export const useAvailableCyoThemeCards = () => {
  const storeClosed = useStoreClosed();
  const [updatedGiftCardTypesText, setUpdatedGiftCardTypesText] = useState<any>();
  const [updatedConfigurationPageImages, setUpdatedConfigurationPageImages] = useState<any>();
  const [updatedConfigurationPageImagesBusiness, setUpdatedConfigurationPageImagesBusiness] = useState<any>();
  const [updatedConfigurationPageDescriptions, setUpdatedConfigurationPageDescriptions] = useState<any>({});

  useEffect(() => {
    if (!storeClosed?.availableCyoThemeCards || storeClosed?.availableCyoThemeCards?.length === 0) {
      return;
    }

    const newTypesText: any = {
      restaurant: 'Restaurants',
      spa: 'Spas & Salons',
      salon: 'Spas & Salons',
      serviceprovider: 'Local Service Providers',
    };
    const newConfigImages: any = {
      restaurant: '/cyo_restaurant_configuration.png',
      spa: '/cyo_spas_and_salons_configuration.png',
      salon: '/cyo_spas_and_salons_configuration.png',
    };
    const newConfigImagesBusiness: any = {
      restaurant: '/cyo_restaurant_configuration.png',
      spa: '/cyo_spas_and_salons_configuration.png',
      salon: '/cyo_spas_and_salons_configuration.png',
    };
    const newconfigDescription: any = {};

    storeClosed?.availableCyoThemeCards?.forEach((card: any) => {
      if (card.key) {
        newConfigImages[card.key] = card.imageFullPath;
        newConfigImagesBusiness[card.key] = card.imageConfigurationFullPath;
      }
    });
    setUpdatedConfigurationPageImages(newConfigImages);
    setUpdatedConfigurationPageImagesBusiness(newConfigImagesBusiness);

    storeClosed?.availableCyoThemeCards?.forEach((card: any) => {
      if (card.key) {
        newTypesText[card.key] = card.title;
        newconfigDescription[card.key] = card.description;
      }
    });
    setUpdatedGiftCardTypesText(newTypesText);
    setUpdatedConfigurationPageDescriptions(newconfigDescription);
  }, [storeClosed?.availableCyoThemeCards]);

  return {
    giftCardTypesText: updatedGiftCardTypesText,
    configurationPageImages: updatedConfigurationPageImages,
    configurationPageImagesBusiness: updatedConfigurationPageImagesBusiness,
    configurationPageDescriptions: updatedConfigurationPageDescriptions,
    updateGiftCardType: (type: string, text: string) => {
      setUpdatedGiftCardTypesText((prev: any) => ({
        ...prev,
        [type]: text,
      }));
    },
  };
};
